import { type CountryCode, type ProjectCode } from '@constants'
import { type CartItem } from '../types'
import { useECommerceProductsInfo } from './useECommerceProductsInfo'
import { useWpCartAllItems } from './useWpCartStore'

export const useWpCartProductsInfo = (
  projectCode: ProjectCode,
  countryCode: CountryCode,
  extraProductIds?: CartItem['cartItemId'][],
  extraSubshipProductIds?: CartItem['cartItemId'][],
) => {
  const cartItems = useWpCartAllItems(countryCode)
  const { productMap, revalidateProductsInfo, isProductsValidating, isProductIdsStale } = useECommerceProductsInfo({ cartItems, projectCode, countryCode, extraProductIds, extraSubshipProductIds })

  return {
    productMap,
    revalidateProductsInfo,
    isProductsValidating,
    isProductIdsStale,
  }
}
